/**
 * API атрибутов = справочник seo_dictionaries (category-service).
 * Реэкспортируем методы pipelineRulesAPI, чтобы страница «Атрибуты» и попапы
 * работали с единым источником, не завязываясь на «Правила этапа 1».
 */
import { pipelineRulesAPI, type SeoDictionaryItem, type SeoDictionaryField } from '../pipeline-rules/api'

export type { SeoDictionaryItem, SeoDictionaryField }

export const attributesAPI = {
  getAll: (field?: SeoDictionaryField) => pipelineRulesAPI.getSeoDictionaries(field),
  save: pipelineRulesAPI.saveSeoDictionary,
  remove: pipelineRulesAPI.deleteSeoDictionary,
  importFromDesigns: pipelineRulesAPI.importSeoDictionariesFromDesigns,
}
